import fetchApi from "../fetchApi";

// Returns the dynamic roles currently assigned to a user: { roles: [{ id, name, description }] }
export const GetUserRolesForUser = async (userId) => {
  const options = {
    method: "GET",
    headers: new Headers({
      "Content-Type": "application/json",
    }),
    redirect: "follow",
  };

  return await fetchApi(`users/${userId}/roles`, options);
};
